import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from '../components/AuthHeader';
import AuthFooter from '../components/AuthFooter';
import { asset } from '../utils/asset';

/**
 * As fotos de fundo do login, e a regra de rodízio.
 *
 * São ambientes com cortina e persiana — o que a Casa A vende. A anterior era a
 * montanha nevada que veio no tema AdminUX, que não dizia nada sobre a loja.
 *
 * **O rodízio é MENSAL, e é determinístico**: a foto sai do mês do calendário,
 * não de sorteio. Duas consequências que valem a escolha:
 *
 *  - **não muda a cada F5.** Fundo que troca a cada carregamento chama atenção
 *    para si numa tela onde o trabalho é digitar a senha;
 *  - **todo mundo vê a mesma coisa no mesmo mês**, então "a tela está diferente
 *    aqui" nunca vira dúvida de suporte.
 *
 * Com três fotos, o ciclo fecha a cada trimestre. Acrescentar uma quarta é
 * acrescentar uma linha aqui — o `% FUNDOS.length` se ajusta sozinho.
 */
const FUNDOS = [
    'assets/img/login/sala-madeira.jpg',
    'assets/img/login/sala-laranja.jpg',
    'assets/img/login/quarto-persiana.jpg',
] as const;

function fundoDoMes(hoje = new Date()): string {
    return FUNDOS[hoje.getMonth() % FUNDOS.length];
}

const AuthLayout: React.FC = () => {
    return (
        <>
            {/* main content */}
            {/* `casaa-login-topo` é o véu que garante a marca legível sobre
                QUALQUER foto — ver `estilos/_login.scss`. */}
            <div className="adminuiux-header inner-page z-index-5 position-relative casaa-login-topo">
                <AuthHeader />
            </div>
            <main className="flex-shrink-0 pt-0">
                <div className="container">
                    <div className="auth-wrapper">
                        {/*Page body*/}
                        <div className="coverimg h-100 w-100 top-0 start-0 position-absolute z-index-0">
                            <img src={asset(fundoDoMes())} alt="" />
                        </div>
                        {/* login wrap */}
                        <Outlet />
                    </div>
                </div>
            </main>
            <div className="adminuiux-footer mt-auto bg-theme-1 z-index-1 position-relative">
                <AuthFooter />
            </div>
        </>
    );
};

export default AuthLayout;
